import WorkerHeader from '../../worker-header/components/index';
import WorkerFooter from "../../worker-footer/components/index";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { fetchWorkerChildCareFacilities, fetchWorkerChildCareFacilitiesInit } from '../slice/workerChildCareFacilitiesSlice';
import { useNavigate } from "react-router-dom";
import Pagination from '../../../../pagination/components';

const PAGE_SIZE = 10;

const fipsOptions = [
    { value: "", label: "All" },
    { value: "001", label: "Accomack" },
    { value: "003", label: "Albemarle" },
    { value: "510", label: "Alexandria" },
    { value: "005", label: "Alleghany" },
    { value: "007", label: "Amelia" },
    { value: "009", label: "Amherst" },
    { value: "011", label: "Appomattox" },
    { value: "013", label: "Arlington" },
    { value: "015", label: "Augusta" },
    { value: "017", label: "Bath" },
    { value: "515", label: "Bedford" },
    { value: "019", label: "Bedford County" },
    { value: "021", label: "Bland" },
    { value: "023", label: "Botetourt" },
    { value: "520", label: "Bristol" },
    { value: "025", label: "Brunswick" },
    { value: "027", label: "Buchanan" },
    { value: "029", label: "Buckingham" },
    { value: "530", label: "Buena Vista" },
    { value: "031", label: "Campbell" },
    { value: "033", label: "Caroline" },
    { value: "035", label: "Carroll" },
    { value: "036", label: "Charles City" },
    { value: "037", label: "Charlotte County" },
    { value: "540", label: "Charlottesville" },
    { value: "550", label: "Chesapeake" },
    { value: "041", label: "Chesterfield" },
    { value: "043", label: "Clarke" },
    { value: "570", label: "Colonial Hts" },
    { value: "580", label: "Covington" },
    { value: "045", label: "Craig" },
    { value: "047", label: "Culpeper" },
    { value: "049", label: "Cumberland" },
    { value: "590", label: "Danville" },
    { value: "051", label: "Dickenson" },
    { value: "053", label: "Dinwiddie" },
    { value: "595", label: "Emporia" },
    { value: "057", label: "Essex" },
    { value: "600", label: "Fairfax City" },
    { value: "059", label: "Fairfax County" },
    { value: "610", label: "Falls Church City" },
    { value: "061", label: "Fauquier" },
    { value: "063", label: "Floyd" },
    { value: "065", label: "Fluvanna" },
    { value: "620", label: "Franklin City" },
    { value: "067", label: "Franklin County" },
    { value: "069", label: "Frederick" },
    { value: "630", label: "Fredericksburg" },
    { value: "640", label: "Galax" },
    { value: "071", label: "Giles" },
    { value: "073", label: "Gloucester" },
    { value: "075", label: "Goochland" },
    { value: "077", label: "Grayson" },
    { value: "079", label: "Greene" },
    { value: "081", label: "Greenville" },
    { value: "083", label: "Halifax" },
    { value: "650", label: "Hampton" },
    { value: "085", label: "Hanover" },
    { value: "660", label: "Harrisonburg" },
    { value: "087", label: "Henrico" },
    { value: "089", label: "Henry" },
    { value: "091", label: "Highland" },
    { value: "670", label: "Hopewell" },
    { value: "093", label: "Isle of Wight" },
    { value: "095", label: "James City" },
    { value: "097", label: "King and Queen" },
    { value: "099", label: "King George" },
    { value: "101", label: "King William" },
    { value: "103", label: "Lancaster" },
    { value: "105", label: "Lee" },
    { value: "678", label: "Lexington" },
    { value: "107", label: "Loudoun" },
    { value: "109", label: "Louisa" },
    { value: "111", label: "Lunenburg" },
    { value: "680", label: "Lynchburg" },
    { value: "113", label: "Madison" },
    { value: "683", label: "Manassas City" },
    { value: "685", label: "Manassas Park" },
    { value: "690", label: "Martinsville" },
    { value: "115", label: "Mathews" },
    { value: "117", label: "Mecklenburg" },
    { value: "119", label: "Middlesex" },
    { value: "121", label: "Montgomery" },
    { value: "125", label: "Nelson" },
    { value: "127", label: "New Kent" },
    { value: "700", label: "Newport News" },
    { value: "710", label: "Norfolk" },
    { value: "131", label: "Northampton" },
    { value: "133", label: "Northumberland" },
    { value: "720", label: "Norton" },
    { value: "135", label: "Nottoway" },
    { value: "137", label: "Orange" },
    { value: "139", label: "Page" },
    { value: "141", label: "Patrick" },
    { value: "730", label: "Petersburg" },
    { value: "143", label: "Pittsylvania" },
    { value: "735", label: "Poquoson" },
    { value: "740", label: "Portsmouth" },
    { value: "145", label: "Powhatan" },
    { value: "147", label: "Prince Edward" },
    { value: "149", label: "Prince George" },
    { value: "153", label: "Prince William" },
    { value: "155", label: "Pulaski" },
    { value: "750", label: "Radford" },
    { value: "157", label: "Rappahannock" },
    { value: "760", label: "Richmond City" },
    { value: "159", label: "Richmond County" },
    { value: "770", label: "Roanoke City" },
    { value: "161", label: "Roanoke County" },
    { value: "163", label: "Rockbridge" },
    { value: "165", label: "Rockingham" },
    { value: "167", label: "Russell" },
    { value: "775", label: "Salem" },
    { value: "169", label: "Scott" },
    { value: "171", label: "Shenandoah" },
    { value: "173", label: "Smyth" },
    { value: "175", label: "Southampton" },
    { value: "177", label: "Spotsylvania" },
    { value: "179", label: "Stafford" },
    { value: "790", label: "Staunton" },
    { value: "800", label: "Suffolk" },
    { value: "181", label: "Surry" },
    { value: "183", label: "Sussex" },
    { value: "185", label: "Tazewell" },
    { value: "810", label: "Virginia Beach" },
    { value: "187", label: "Warren" },
    { value: "191", label: "Washington" },
    { value: "820", label: "Waynesboro" },
    { value: "193", label: "Westmoreland" },
    { value: "830", label: "Williamsburg" },
    { value: "840", label: "Winchester" },
    { value: "195", label: "Wise" },
    { value: "197", label: "Wythe" },
    { value: "199", label: "York" },
];

const WorkerChildCareFacilities = () => {
    const dispatch = useDispatch();

    const { loading, error, childCareFacilitiesData, childCareFacilitiesDataInit, initLoading, initError } = useSelector(
        (state) => state.workerChildCareFacilities
    );
    const [activeTab, setActiveTab] = useState('licensed');
    const [btnLoading, setBtnLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        const loadInitialData = async () => {
            try {
                await dispatch(fetchWorkerChildCareFacilitiesInit({ rm: "Search" }));
            } catch (error) {
                console.error(error);
            }
        };

        loadInitialData();
    }, [dispatch]);

    const allFacilities = [
        ...(childCareFacilitiesDataInit?.licensed || []),
        ...(childCareFacilitiesDataInit?.unlicensed || [])
    ];

    const [filters, setFilters] = useState({
        category: '',
        state: '',
        zip: '',
        includeModifiers: false,
        facilityTypes: []
    });

    const handleSearch = async () => {
        setBtnLoading(true);
        setHasSearched(true);
        try {
            const params = {
                rm: 'Search',
                search_keywords_name: filters.category || '',
                search_exact_fips: filters.state || '',
                search_contains_zip: filters.zip || '',
                selectedTypes: filters.facilityTypes
            };

            if (filters.includeModifiers) {
                params.search_modifiers_mod_cde = 1; // API expects 1 when checked
            }

            await dispatch(fetchWorkerChildCareFacilities(params));
        } catch (error) {
            console.error(error);
        } finally {
            setBtnLoading(false);
        }
    };


    const facilities =
        activeTab === 'licensed'
            ? childCareFacilitiesData?.licensed || []
            : childCareFacilitiesData?.unlicensed || [];

    const toggleFacilityType = (value) => {
        setFilters(prev => ({
            ...prev,
            facilityTypes: prev.facilityTypes.includes(value)
                ? prev.facilityTypes.filter(v => v !== value) // remove
                : [...prev.facilityTypes, value] // add
        }));
    };

    const totalPages = Math.ceil(facilities.length / PAGE_SIZE);

    const paginatedFacilities = facilities.slice(
        (currentPage - 1) * PAGE_SIZE,
        currentPage * PAGE_SIZE
    );

    useEffect(() => {
        setCurrentPage(1);
    }, [activeTab]);


    return (
        <>
            <WorkerHeader />

            <main className="overflow-hidden">
                <section className="homepad pb-5">
                    <div className="container">
                        <h4 className="text-left mb-4 pb-2 font-weight-bold text-primary display-6 montserrat">
                            Find ChildCare Facilities
                        </h4>

                        <div className="row">
                            {/* Form section - matches jobs section width */}
                            <div className="col-12 col-lg-9 mx-auto">
                                <div className="form-section bg-light rounded p-3 p-sm-4">

                                    {/* SEARCH INPUTS */}
                                    <div className="row g-6">
                                        <div className="col-md-5 position-relative">
                                            {/* <input
                                                className="form-control rounded-pill shadow-sm flex-grow-1"
                                                placeholder="Facility Name"
                                                value={filters.category}
                                                onChange={(e) =>
                                                    setFilters({ ...filters, category: e.target.value })
                                                }
                                            /> */}
                                            {/* <input
                                                    className="form-control rounded-pill shadow-sm flex-grow-1"
                                                    placeholder="Facility Name"
                                                    value={filters.category}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setFilters({ ...filters, category: value });

                                                        if (value.length >= 1) {
                                                            const filtered = allFacilities.filter(facility =>
                                                                facility.facilityName
                                                                    ?.toLowerCase()
                                                                    .includes(value.toLowerCase())
                                                            );

                                                            setSuggestions(filtered.slice(0, 5)); // limit to 5 suggestions
                                                        } else {
                                                            setSuggestions([]);
                                                        }
                                                    }}
                                                /> */}
                                            <input
                                                className="form-control rounded-pill shadow-sm flex-grow-1 pe-5"
                                                placeholder="Facility Name"
                                                value={filters.category}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setFilters({ ...filters, category: value });

                                                    if (value.length >= 1) {
                                                        const filtered = allFacilities.filter(facility =>
                                                            facility.facilityName
                                                                ?.toLowerCase()
                                                                .includes(value.toLowerCase())
                                                        );

                                                        setSuggestions(filtered.slice(0, 10));
                                                    } else {
                                                        setSuggestions([]);
                                                    }
                                                }}
                                            />

                                            {/* Spinner */}
                                            {initLoading && (
                                                <div
                                                    className="position-absolute top-50 end-0 translate-middle-y me-4"
                                                >
                                                    <div
                                                        className="spinner-border spinner-border-sm text-primary"
                                                        role="status"
                                                    >
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            )}

                                            {suggestions.length > 0 && (
                                                <ul className="list-group position-absolute shadow">
                                                    {suggestions.map((item, index) => (
                                                        <li
                                                            key={index}
                                                            className="list-group-item list-group-item-action"
                                                            onClick={() => {
                                                                setFilters({
                                                                    ...filters,
                                                                    category: item.facilityName
                                                                });
                                                                setSuggestions([]);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        >
                                                            {item.facilityName}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}


                                        </div>

                                        <div className="col-md-2">
                                            <select
                                                className="form-control rounded-pill shadow-sm flex-grow-1"
                                                value={filters.state}
                                                onChange={(e) => setFilters({ ...filters, state: e.target.value })}
                                            >
                                                {fipsOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>


                                        <div className="col-md-2">
                                            <input
                                                className="form-control rounded-pill shadow-sm flex-grow-1"
                                                placeholder="Zip code"
                                                value={filters.zip}
                                                onChange={(e) =>
                                                    setFilters({ ...filters, zip: e.target.value })
                                                }
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <div className="d-flex align-items-center">
                                                <label
                                                    className="form-check-label fw-bold"
                                                    htmlFor="includeModifiers"
                                                >
                                                    Current Subsidy Provider
                                                </label>
                                                <input
                                                    className="form-check-input ms-2"
                                                    type="checkbox"
                                                    id="includeModifiers"
                                                    checked={filters.includeModifiers}
                                                    onChange={(e) =>
                                                        setFilters({
                                                            ...filters,
                                                            includeModifiers: e.target.checked
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col-md-12 mt-3">
                                        <label className="form-label fw-bold">Licensed</label>
                                        <div className="d-flex gap-3 flex-wrap">
                                            {[
                                                { value: "child_day_center", label: "Child Day Center" },
                                                { value: "family_day_home", label: "Family Day Home" },
                                                { value: "short_term_child_day_center", label: "Short-Term Child Day Center" },
                                            ].map((type) => (
                                                <div key={type.value} className="form-check d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        id={type.value}
                                                        value={type.value}
                                                        checked={filters.facilityTypes.includes(type.value)}
                                                        onChange={() => toggleFacilityType(type.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor={type.value}>
                                                        {type.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="col-md-12 mt-3">
                                        <label className="form-label fw-bold">Regulated Unlicensed</label>
                                        <div className="d-flex gap-3 flex-wrap">
                                            {[
                                                { value: "religious_exempt_child_day_center", label: "Religious Exempt Child Day Center" },
                                                { value: "voluntary_registered_day_homes", label: "Voluntary Registered Day Homes" },
                                                { value: "certified_pre_school", label: "Certified Pre-School" },
                                            ].map((type) => (
                                                <div key={type.value} className="form-check d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        id={type.value}
                                                        value={type.value}
                                                        checked={filters.facilityTypes.includes(type.value)}
                                                        onChange={() => toggleFacilityType(type.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor={type.value}>
                                                        {type.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="col-md-12 mt-3">
                                        <label className="form-label fw-bold">Other Unlicensed</label>
                                        <div className="d-flex gap-3 flex-wrap">
                                            {[
                                                { value: "center_based", label: "Center Based" },
                                                { value: "home_based", label: "Home Based" },
                                            ].map((type) => (
                                                <div key={type.value} className="form-check d-flex align-items-center">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        id={type.value}
                                                        value={type.value}
                                                        checked={filters.facilityTypes.includes(type.value)}
                                                        onChange={() => toggleFacilityType(type.value)}
                                                    />
                                                    <label className="form-check-label" htmlFor={type.value}>
                                                        {type.label}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        <button
                                            className="btn btn-primary rounded-pill shadow-sm mt-3"
                                            style={{ width: "15%" }}
                                            disabled={btnLoading}
                                            onClick={handleSearch}
                                        >
                                            {/* Search */}
                                            {btnLoading ? (
                                                <span className="d-flex align-items-center justify-content-center">
                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                    Searching...
                                                </span>
                                            ) : (
                                                <span className="d-block font-size-18">Search</span>
                                            )}
                                        </button>
                                    </div>





                                </div>
                                {/* LOADING */}
                                {loading ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                ) : error ? (
                                    <p className="text-danger">{error}</p>
                                ) : facilities.length > 0 ? (
                                    <>
                                        <ul className="nav nav-tabs mt-4">
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 'licensed' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('licensed')}
                                                >
                                                    Licensed ({childCareFacilitiesData.licensedCount})
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    className={`nav-link ${activeTab === 'unlicensed' ? 'active' : ''}`}
                                                    onClick={() => setActiveTab('unlicensed')}
                                                >
                                                    Unlicensed ({childCareFacilitiesData.unlicensedCount})
                                                </button>
                                            </li>
                                        </ul>

                                        <div className="mt-3 form-section bg-light rounded p-3 p-sm-4">
                                            {paginatedFacilities.map((item, i) => (
                                                <div key={i} className="card activity-card p-4 position-relative">

                                                    <div className="d-flex justify-content-between align-items-start">

                                                        {/* Left Side Content */}
                                                        <div>
                                                            <h6 className="font-weight-bold text-primary font-size-22 mb-2 montserrat">
                                                                <span
                                                                    className="facility-link"
                                                                    role="button"
                                                                    onClick={() =>
                                                                        navigate("/worker-child-care-facility-details", {
                                                                            state: {
                                                                                facilityLink: item.facilityLink
                                                                            }
                                                                        })
                                                                    }
                                                                    style={{ cursor: "pointer" }}
                                                                >
                                                                    {item.facilityName}
                                                                </span>
                                                            </h6>

                                                            <div className="text-muted font-size-14 mb-2">
                                                                <strong>Location:</strong> {item.street}
                                                                {item.city && `, ${item.city}`}
                                                                {item.state && `, ${item.state}`}
                                                                {item.zip && ` ${item.zip}`}
                                                            </div>

                                                            <div className="text-muted font-size-14 mb-2">
                                                                <strong>Contact:</strong> {item.phone}
                                                            </div>
                                                        </div>

                                                        {/* Right Side Button */}
                                                        <div>
                                                            <button
                                                                className="btn btn-primary btn-sm"
                                                                onClick={() =>
                                                                    navigate("/worker-child-care-facility-details", {
                                                                        state: {
                                                                            facilityLink: item.facilityLink
                                                                        }
                                                                    })
                                                                }
                                                            >
                                                                View Details
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Pagination */}
                                        {totalPages > 1 && (
                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                onPageChange={(page) => setCurrentPage(page)}
                                            />
                                        )}
                                    </>
                                ) : hasSearched ? (
                                    /* 🔴 AFTER SEARCH – NO RESULTS */
                                    <div className="form-section bg-light rounded p-3 p-sm-4 mt-3">
                                        <div className="text-center py-5">
                                            <h5 className="text-muted">No facilities found</h5>
                                        </div>
                                    </div>
                                ) : (
                                    /* 🟢 INITIAL LOAD */
                                    <div className="form-section bg-light rounded p-3 p-sm-4 mt-3">
                                        <div className="text-center py-5">
                                            <h5 className="text-muted">
                                                Please enter search criteria to see results.
                                            </h5>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Support card - right side */}
                            <div className="col-12 col-lg-3">
                                <div className="support-card text-white bg-primary rounded15 p-4">
                                    <div className="p-md-2">
                                        <h5 className="font-weight-semibold font-size-18 mb-3">Need Help?</h5>
                                        <p className="mb-3">Reach out to our support executive<br />for any help</p>
                                        <div className="phone-number my-4">
                                            <img src="/assets/images/phone-call-01.svg" className="img-fluid" alt="" />
                                            <span>+91-6353385120</span>
                                        </div>
                                        <a href="https://wa.me/916353385120" target="_blank" className="whatsapp-button">
                                            <img src="/assets/images/chat-whatsapp-icon.svg" className="img-fluid" alt="" />
                                            Chat on Whatsapp
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <div className="mobile-mt-services">
                    <WorkerFooter />
                </div>
            </main>
        </>
    );
};

export default WorkerChildCareFacilities;